'use strict'

export default {

  /**
   * Get current playing game by table id.
   */
  async getCurrent(id) {
    return await axios.get(`/bingo/${id}/current?req=${makeid(10)}`)
  },

  /**
   * Get stats by table id.
   */
  async getStats(id) {
    return await axios.get(`/bingo/${id}/stats`)
  },

  /**
   * Post bet to api.
   */
  async postBet({
    tableId,
    gameId = 1,
    data = {}
  } = {}) {
    const postData = {
      table_id: tableId,
      game_id: gameId,
      chip: data,
      again: true
    }
    console.log(postData);
    axios.defaults.headers.common['Content-Type'] = 'application/vnd.api+json'
    return await axios.post('/bingo/bet', postData)
  }

}


// WEBPACK FOOTER //
// ./resources/assets/js/casino/api/bingo.js